import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2, Heart } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_POLLS = 8;

export const PaymentSuccessDe = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("polling");
  const [detail, setDetail] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return;
    }
    let timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        setDetail(data);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) {
          setState("error");
          return;
        }
      } catch (e) {
        // keep trying up to the limit
      }
      attempts.current += 1;
      if (attempts.current >= MAX_POLLS) {
        setState("timeout");
        return;
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => timer && clearTimeout(timer);
  }, [sessionId]);

  return (
    <main className="pay-result-wrap">
      <div className="pay-result soft-card">
        {state === "polling" && (
          <>
            <Loader2 size={44} className="spin" color="var(--gold-ink)" />
            <h1 className="pay-result-title">Wir bestätigen deinen Beitrag …</h1>
            <p className="pay-result-sub">Einen stillen Moment, während wir mit Stripe bestätigen.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <span className="pay-result-icon success"><CheckCircle2 size={40} /></span>
            <h1 className="pay-result-title">Danke für dein Dana</h1>
            <p className="pay-result-sub">
              {detail?.amount ? `Dein Beitrag von €${Number(detail.amount).toFixed(2)}` : "Dein Beitrag"}
              {detail?.recurring ? " pro Monat" : ""}
              {detail?.path ? ` für den Weg „${detail.path}“` : ""} wurde mit tiefer Dankbarkeit empfangen.
              Eine Bestätigung folgt per E-Mail.
            </p>
            <Link to="/de/kontakt" className="btn-gold" style={{ marginTop: "1.5rem" }}>
              <Heart size={16} /> Zurück zum Kontakt
            </Link>
          </>
        )}
        {state === "timeout" && (
          <>
            <span className="pay-result-icon neutral"><Loader2 size={40} /></span>
            <h1 className="pay-result-title">Wird noch verarbeitet</h1>
            <p className="pay-result-sub">
              Deine Zahlung braucht etwas länger als üblich zur Bestätigung. Falls Stripe dich belastet hat,
              wird sie in Kürze abgeschlossen — schau gern in dein E-Mail-Postfach.
            </p>
            <Link to="/de/kontakt" className="btn-ghost" style={{ marginTop: "1.5rem" }}>Zurück zum Kontakt</Link>
          </>
        )}
        {state === "error" && (
          <>
            <span className="pay-result-icon error"><XCircle size={40} /></span>
            <h1 className="pay-result-title">Wir konnten diese Zahlung nicht bestätigen</h1>
            <p className="pay-result-sub">Möglicherweise wurde keine Belastung vorgenommen. Du bist herzlich eingeladen, es erneut zu versuchen.</p>
            <Link to="/de/kontakt" className="btn-ghost" style={{ marginTop: "1.5rem" }}>Zurück zum Kontakt</Link>
          </>
        )}
      </div>
    </main>
  );
};

export const PaymentCancelDe = () => (
  <main className="pay-result-wrap">
    <div className="pay-result soft-card">
      <span className="pay-result-icon neutral"><XCircle size={40} /></span>
      <h1 className="pay-result-title">Beitrag nicht abgeschlossen</h1>
      <p className="pay-result-sub">
        Dein Bezahlvorgang wurde abgebrochen und es wurde keine Zahlung getätigt. Wann immer du dich bereit fühlst, ist dein Dana stets willkommen.
      </p>
      <Link to="/de/kontakt" className="btn-gold" style={{ marginTop: "1.5rem" }}>
        <Heart size={16} /> Zurück zum Kontakt
      </Link>
    </div>
  </main>
);

export default PaymentSuccessDe;
